const BANNER_DISMISSED_KEY = 'saloni-pwa-install-banner-dismissed';

export function wasPwaInstallBannerDismissed() {
  try {
    return window.localStorage.getItem(BANNER_DISMISSED_KEY) === '1';
  } catch {
    return false;
  }
}

export function dismissPwaInstallBanner() {
  try {
    window.localStorage.setItem(BANNER_DISMISSED_KEY, '1');
  } catch {
    /* ignore */
  }
}
